import {useMutation} from "@apollo/client";
import {EditArticleDataDocument, EditArticleDataInput} from "generated/graphql";

export const useEditArticleData = () => {
  const [mutate] = useMutation(EditArticleDataDocument);

  return (input: EditArticleDataInput) => mutate({ variables: {input} });
}